import { Container } from '@workramp/ui';
import styled from 'styled-components';

export const IntegrationContainer = styled(Container)`
  padding-top: ${({ theme }) => `${theme.spacing(8)}px`};
  padding-bottom: ${({ theme }) => `${theme.spacing(10)}px`};
`;

export const TextFieldWrapper = styled.div`
  position: relative;
  max-width: 654px;
`;

export const StyledLink = styled.a`
  color: ${(props) => props.theme.colors.primary[600]};
  &:visited,
  &:link {
    color: ${(props) => props.theme.colors.primary[600]};
  }
`;

export const CenterAlign = styled.div`
  text-align: center;
`;

export const IntegrationHomeProviderIconContainer = styled.div`
  border-radius: ${({ theme }) => theme.radii.md}px;
  border: 1px solid ${({ theme }) => theme.colors.on[50]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => `${theme.spacing(8)}px`};
  width: ${({ theme }) => `${theme.spacing(8)}px`};

  & svg,
  & img {
    width: ${({ theme }) => `${theme.spacing(6)}px`};
    height: ${({ theme }) => `${theme.spacing(6)}px`};
  }
`;

export const IntegrationProviderIconContainer = styled.div`
  border-radius: ${({ theme }) => theme.radii.md}px;
  border: 1px solid ${({ theme }) => theme.colors.on[50]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => `${theme.spacing(18)}px`};
  width: ${({ theme }) => `${theme.spacing(18)}px`};

  & svg,
  & img {
    width: ${({ theme }) => `${theme.spacing(16)}px`};
    height: ${({ theme }) => `${theme.spacing(16)}px`};
  }
`;
